import {computed} from 'mobx';
import {BaseModel} from "../../../../../infrastructure/models/base-model";
import {DEFAULT_CULTURE_NAME} from "../../../../app/consts";

export class RedirectModel extends BaseModel {
  name: String;
  cultureName: String;

  constructor(name: String, cultureName: String, exact: Boolean = true) {
    super();

    this.name = name;
    this.cultureName = cultureName;
    this.exact = exact;
  }

  @computed get languageDisplayName(): String {
    const path: String = this.cultureName === DEFAULT_CULTURE_NAME ? "" : '/' + this.cultureName;

    return path;
  }

  @computed get from() {
    return console.error(this.constructor.name + 'Implementation is missing: from');
  }

  @computed get to() {
    return console.error(this.constructor.name + 'Implementation is missing: to');
  }

  get currentPathParams() {
    return window.location.pathname.split('/')
  }
}
